'use client';
import React, { use } from 'react';
import { EventCategoryType } from '@/types/EventCategoryType.type';
import { Skeleton } from '@/components/ui';
import { CategoryCard } from './components';

interface CategoriesSectionProps {
  categoriesData: Promise<EventCategoryType[]> | null;
}

export default function CategoriesSection({
  categoriesData,
}: CategoriesSectionProps): React.ReactNode {
  const categories = categoriesData ? use(categoriesData) : null;
  return (
    <section className='w-full sm:pb-0 mt-12'>
      <div className='mx-auto max-w-7xl px-3.5 pb-4 md:px-6 lg:px-8'>
        <div className='flex flex-col items-center pb-3'>
          <p className='w-full xs:text-2xl mt-0 text-xl font-bold text-gray-800 sm:text-xl'>
            Explore. Discover. Make a Plan
          </p>
        </div>
        <div className='hide-scrollbar grid w-full grid-flow-dense grid-cols-2 place-items-center gap-2 sm:grid-cols-3 md:grid-cols-3 md:gap-5 lg:grid-cols-5 lg:gap-4 xl:grid-cols-6 xl:gap-4'>
          {categories
            ? categories?.map((category: EventCategoryType) => (
                <CategoryCard key={`${category._id}`} category={category} />
              ))
            : Array.from({ length: 6 }).map((_, index) => (
                <Skeleton
                  key={`CATEGORY_SKELETON_${index}`}
                  className='h-28 w-full md:h-40'
                />
              ))}
        </div>
      </div>
    </section>
  );
}
